import { OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
var ContainerBase = /** @class */ (function () {
    function ContainerBase() {
        this.destroyedSubject = new Subject();
    }
    Object.defineProperty(ContainerBase.prototype, "destroyed$", {
        get: function () {
            return this.destroyedSubject;
        },
        enumerable: true,
        configurable: true
    });
    ContainerBase.prototype.ngOnDestroy = function () {
        this.destroyedSubject.next();
        this.destroyedSubject.complete();
    };
    return ContainerBase;
}());
export { ContainerBase };
